// extracted by mini-css-extract-plugin
export default {"bannerHeading":"watch_bannerHeading__Xgpzq"};